import { dragActions } from "@/action/dragActions";
import { linkActions } from "@/action/linkActions";
import type { DragHandlers } from "@/components/gestures/drag";
import { boardFromWindow, relativeFromBoard } from "@/math/coordinate-transform";
import { relativeClientCoord } from "@/math/coordinate-utils";
import type { Card } from "@/model/card";
import type { BoardCoordinate } from "@/model/coordinates";
import { useDraggingStore } from "@/store/dragging";
import { elemOffsetCoord } from "@/utils/dom/coordinates";

export function linkDragHandler(e: PointerEvent, card: Card, onEnd: () => void): DragHandlers {
  let origin: BoardCoordinate = null!;

  return {
    start(drag) {
      drag.el = drag.imageEl = drag.target;
      drag.setOffset("zero");
      drag.el.style.display = "none";
      dragActions.startLinkDrag("mouse", card, drag.pointerId, relativeClientCoord(e));
      origin = elemOffsetCoord(drag.el);
    },

    move(drag) {
      useDraggingStore().dragLink(
        drag.pointerId,
        relativeFromBoard(boardFromWindow(drag.pos, "none")),
      );
      return drag.pos;
    },

    stop(drag) {
      const val = { dragId: drag.pointerId, id: card.id, el: drag.el };
      void linkActions.addByDrag("drag", val);
      onEnd();
      return { ...origin };
    },
  };
}
